/**
 * Порожній стан списку.
 *
 * Раніше це були рядки на кшталт «Для відображення деталей виберіть
 * замовлення в сусідньому меню» всередині emptyMessage таблиці —
 * без іконки й без підказки, що робити далі.
 */
const EmptyState = ({ icon = 'pi pi-inbox', title, text, action }) => (
    <div className="rc-empty">
        <div className="rc-empty__icon">
            <i className={icon} />
        </div>
        {title && <div className="rc-empty__title">{title}</div>}
        {text && <div className="rc-empty__text">{text}</div>}
        {action}
    </div>
);

export default EmptyState;
